<template>
  <div>
    <v-row class="ma-4">
        <p>Dados Técnicos do trilho</p>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.length"
          label="Comprimento (mm)"
          v-bind:options="optionsInteger"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.weight"
          label="Peso (kg)"
          v-bind:options="optionsBr"
        />
      </v-col>
      
    </v-row>

  </div>
</template>



<script>
export default {
  components: {
  },

  name: "edit-rail",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
            optionsBr: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      optionsInteger: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 0,
      },
      selected: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  methods: {
    
    
  },
};
</script>
